export function useLocaleProperties() {
  const { $i18n: { localeProperties } } = useNuxtApp()
  return { localeProperties: toValue(localeProperties) }
}
